import React from "react";
import { Checkbox } from "components/designV2/checkbox/checkbox";
import {
  EmptyState,
  List,
  ListScroll,
  Option,
  OptionCheckbox,
  OptionLabel,
  OptionRight,
  OptionRightText,
} from "./searchableDropdown.styles";
import { SearchableDropdownOption } from "./searchableDropdown.types";

export interface SearchableDropdownListProps {
  listboxId: string;
  labelId?: string;
  isOpen: boolean;
  zIndex: number;
  multiSelect?: boolean;
  filteredOptions: SearchableDropdownOption[];
  highlightedIndex: number;
  selectedValueSet: Set<string>;
  value?: string;
  emptyText: string;
  onSelect: (option: SearchableDropdownOption) => void;
}

/** Renders the dropdown listbox and options. */
export const SearchableDropdownList = (
  props: SearchableDropdownListProps,
): React.ReactElement => {
  return (
    <List
      id={props.listboxId}
      role="listbox"
      aria-labelledby={props.labelId}
      aria-multiselectable={props.multiSelect ? "true" : undefined}
      $isOpen={props.isOpen}
      $zIndex={props.zIndex}
    >
      <ListScroll>
        {props.filteredOptions.map((option, index) => {
          const isSelected = props.multiSelect
            ? props.selectedValueSet.has(option.value)
            : option.value === props.value;
          const isHighlighted = index === props.highlightedIndex;
          return (
            <Option
              key={option.value}
              id={`${props.listboxId}-option-${index}`}
              role="option"
              aria-selected={isSelected}
              $isSelected={isSelected}
              $isHighlighted={isHighlighted}
              $isMultiSelect={Boolean(props.multiSelect)}
              onClick={() => props.onSelect(option)}
            >
              <OptionLabel>{option.label}</OptionLabel>
              <OptionRight>
                {option.rightText && (
                  <OptionRightText>{option.rightText}</OptionRightText>
                )}
                {props.multiSelect && (
                  <OptionCheckbox onClick={(event) => event.stopPropagation()}>
                    <Checkbox
                      checked={isSelected}
                      onChange={() => props.onSelect(option)}
                    />
                  </OptionCheckbox>
                )}
              </OptionRight>
            </Option>
          );
        })}
        {props.filteredOptions.length === 0 && (
          <EmptyState>{props.emptyText}</EmptyState>
        )}
      </ListScroll>
    </List>
  );
};
